import { createFileRoute } from "@tanstack/react-router";
import { BabylonSceneWrapper } from "@/babylon/components/BabylonSceneWrapper";
import { StateInspector } from "@/pages/3d/debug/StateInspector";

export const Route = createFileRoute("/demo/3d/debug/state-inspector")({
  component: () => (
    <BabylonSceneWrapper>
      <StateInspector />
    </BabylonSceneWrapper>
  ),
});
